import { Provider } from 'react-redux'
import React from 'react'
import getRootComponent from '../../utils/get-root-component'

const AdminProvider = props => (
  <Provider store={props.store}>{getRootComponent(props.type)}</Provider>
)

export default AdminProvider
